import React from 'react';
import LegacyTextButton, { TextButtonProps } from './TextButton.legacy';
import AlphaTextButton from './TextButton.alpha';

const Component = process.env.IS_LEGACY ? LegacyTextButton : AlphaTextButton;
export default Component as React.FC<TextButtonProps>;
export type { TextButtonProps };
